import React from "react";

import Pattern from "../Pattern";

const GutterGridItem = props => (
  <div className="gutter-grid__item">
    <div className="gutter-grid__item-img">
      <Pattern pattern={props.pattern} thumbnail />
    </div>
    <div className="gutter-grid__item-title">{props.pattern["title_"+props.lng]}</div>
  </div>
);

export default GutterGridItem;



// WEBPACK FOOTER //
// ./src/components/grid/GutterGridItem.js